import { render, staticRenderFns } from "./plan-price-summary.vue?vue&type=template&id=3edd3688"
import script from "./plan-price-summary.js?vue&type=script&lang=js&external"
export * from "./plan-price-summary.js?vue&type=script&lang=js&external"
import style0 from "./plan-price-summary.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports